import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService, HttpMethod } from '../common/api.service';
import { ApiUrlService } from '../common/api-url.service';
import { Observable, of } from 'rxjs';
import * as saveFile from 'file-saver';
import { ImageAsset } from './image-asset-model';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ImageApiService
{
    protected apiService: ApiService;

    private pendingCalls: any[] = [];
    private MAX_CONCURRENT_IMAGE_REQUESTS = 10;

    constructor(protected http: HttpClient,
                protected apiUrlService: ApiUrlService)
    {
        this.apiService = new ApiService(http);
    }

    downloadImageAsset(imageAsset: ImageAsset): Observable<boolean>
    {
        const original = imageAsset.Images.find(i => i.IsOriginal);
        const filename = original.Uri.split('/').pop().split('#')[0].split('?')[0];
        return this.apiService.apiGetRequestForBlob(original.Uri + `?v=${(new Date()).getTime()}`).pipe(
            map(blob =>
            {
                saveFile(blob, filename);
                return true;
            }));
    }

    getImageWithSize(imageId: number, width: number, height: number)
    {
        const pendingCall = { imageId: imageId, width: width, height: height, processing: false, observer: null };
        this.pendingCalls.push(pendingCall);
        return Observable.create(observer =>
        {
            pendingCall.observer = observer;
            if (this.pendingCalls.length > this.MAX_CONCURRENT_IMAGE_REQUESTS) return; // We will process later

            this.processPendingCall(pendingCall);
        });
    }

    private processPendingCall(pendingCall: any)
    {
        pendingCall.processing = true;
        this.apiService.apiRequest<any>(this.apiUrlService.getImageUrlWithSizeUrl(pendingCall.imageId, pendingCall.width, pendingCall.height), HttpMethod.Get)
            .subscribe(response =>
            {
                this.pendingCalls = this.pendingCalls.filter(call => call.imageId !== pendingCall.imageId || call.width !== pendingCall.width || call.height !== pendingCall.height);
                pendingCall.observer.next(response);
                pendingCall.observer.complete();

                this.checkForPendingCall();
            }, error =>
            {
                this.pendingCalls = this.pendingCalls.filter(call => call.imageId !== pendingCall.imageId || call.width !== pendingCall.width || call.height !== pendingCall.height);
                pendingCall.observer.error(error);
                this.checkForPendingCall();
            });
    }

    private checkForPendingCall()
    {
        // Get the next one that is pending
        const nextCall = this.pendingCalls.find(call => !call.processing);
        if (nextCall != null)
        {
            this.processPendingCall(nextCall);
        }
    }
}
